import { ReactComponent as BinIcon } from "./bin-5-fill.svg";
import { ReactComponent as FireIcon } from "./fire-fill.svg";
import { ReactComponent as FloodIcon } from "./flood-fill.svg";
import { ReactComponent as LightIcon } from "./lightbulb-fill.svg";
import { ReactComponent as WaterIcon } from "./water-fill.svg";
import { ReactComponent as Landscaping } from "./landscaping.svg";
import { ReactComponent as GasHeat } from "./gas-heat.svg";
import { ReactComponent as Electricity } from "./electricity.svg";
import { ReactComponent as ElectricityCommerc } from "./electricity-commerc.svg";
import { ReactComponent as Solar } from "./solar.svg";
import { ReactComponent as Satelite } from "./satelite.svg";
import { ReactComponent as Internet } from "./internet.svg";

export const UTILITYICONS = {
  WATERICON: <WaterIcon />,
  BINICON: <BinIcon />,
  FIREICON: <FireIcon />,
  FLOODICON: <FloodIcon />,
  LIGHTICON: <LightIcon />,
  LANDSCAPING: <Landscaping />,
  GASHEAT: <GasHeat />,
  SATELITE: <Satelite />,
  ELECTRICITY: <Electricity />,
  ELECTRICITYCOMMERC: <ElectricityCommerc />,
  SOLAR: <Solar />,
  INTERNET: <Internet />,
};
